import React from "react";
var css = {
  "modal": "rui-iSZ8U",
  "overlay": "rui-oAIXM",
  "modalContent": "rui-Uw4SN",
  "close": "rui-YBgww"
};
import Icon from "../Icon/Icon";
import classNames from "classnames";
var Modal = function Modal(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? "cross" : _ref$icon,
    title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: css.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: css.overlay,
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: 0
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.modalContent, className)
  }, icon && (/*#__PURE__*/React.createElement("span", {
    className: css.close,
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: "blackIcons",
    size: 25
  }))), title && /*#__PURE__*/React.createElement("h2", null, title), children));
};
export default Modal;